









import { defineComponent } from '@nuxtjs/composition-api'
import TechLinks from '@/components/feature/PDP/TechLinks.vue'
import TechLinksSkeleton from '@/components/global/skeletons/TechLinksSkeleton.vue'
import { ATG_BE_CONF } from '~/common/utils/product/constants'

export default defineComponent({
  components: { TechLinks, TechLinksSkeleton },
  setup() {
    return { ATG_BE_CONF }
  },
})
